namespace Ir.Components.General.ColorPicker {

    export interface IColorPickerParams {
        color: KnockoutObservable<string>;
        disabled?: KnockoutObservable<boolean>;
        enabled?: KnockoutObservable<boolean>;
        type?: "text" | "component" | "color" | "flat";
        showInitial?: boolean;
        hideAfterPaletteSelect?: boolean;
        allowEmpty?: boolean;
        showInput?: boolean;
        appendTo?: any;
    }

    interface IViewModel {
        dispose(),
    }
    interface IParams {
        config: IColorPickerParams;
    }

    export function getViewModel(this: IViewModel, params: IParams, componentInfo) {
        let config = params.config;

        var inputColor = $("input", $(componentInfo.element));

        (inputColor as any).spectrum({
            color: config.color(),
            preferredFormat: "hex",
            type: config.type ?? "color",
            hideAfterPaletteSelect: config.hideAfterPaletteSelect === undefined ? true : config.hideAfterPaletteSelect,
            showInitial: config.showInitial === undefined ? true : config.showInitial,
            showAlpha: config.showInitial === undefined ? false : config.showInitial,
            allowEmpty: config.allowEmpty === undefined ? true : config.allowEmpty,
            showInput: config.showInput === undefined ? true : config.showInput,
            disabled: config.disabled ? config.disabled() : (config.enabled ? !config.enabled() : false),
            appendTo: config.appendTo === undefined ? "body" : (config.appendTo === "parent" ? componentInfo.element : config.appendTo),
            change: function (color) {
                if (color)
                    params.config.color(color.toHexString());
                else
                    params.config.color("");
            }
        }) as any;

        var disabledSubscription;
        var enabledSubscription;

        if (config.enabled) {
            enabledSubscription = config.enabled.subscribe(function (newValue) {
                (inputColor as any).spectrum(newValue ? "enable" : "disable");
            });
        }
        if (config.disabled) {
            disabledSubscription = config.disabled.subscribe(function (newValue) {
                (inputColor as any).spectrum(newValue ? "disable" : "enable");
            });
        }
        var valueSubscription = config.color.subscribe(function (newValue) {
            (inputColor as any).spectrum("set", newValue);
        });

        this.dispose = function () {
            disabledSubscription?.dispose();
            enabledSubscription?.dispose();
            valueSubscription.dispose();
        }
    }
}